"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscoverState = void 0;
var HeroinTypes_1 = require("@CommonFrontend/Utils/HeroinTypes");
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var StartBeacon_1 = __importDefault(require("Common/Bootstrapper/InitialiseApp/StartBeacon"));
var inversify_1 = require("inversify");
var mobx_1 = require("mobx");
var OnboardingStore_1 = __importDefault(require("Onboarding/OnboardingStore"));
var DiscoverState;
(function (DiscoverState) {
    DiscoverState["Idle"] = "idle";
    DiscoverState["SidebarOpen"] = "sidebarOpen";
    DiscoverState["HelpScoutOpen"] = "helpScoutOpen";
})(DiscoverState = exports.DiscoverState || (exports.DiscoverState = {}));
var DiscoverStore = (function () {
    function DiscoverStore(onboardingStore, usingFeature, di, initSubscription, trial) {
        var _this = this;
        this.onboardingStore = onboardingStore;
        this.usingFeature = usingFeature;
        this.di = di;
        this.initSubscription = initSubscription;
        this.trial = trial;
        this.state = DiscoverState.Idle;
        this.initBeacon = function () {
            _this.di.invoke(StartBeacon_1.default);
            _this.Beacon("on", "close", (0, mobx_1.action)(function () {
                _this.state = DiscoverState.Idle;
            }));
            _this.Beacon("on", "open", (0, mobx_1.action)(function () {
                _this.state = DiscoverState.HelpScoutOpen;
            }));
        };
        this.upgradeTrialAccount = function () {
            if (_this.state === DiscoverState.SidebarOpen) {
                _this.state = DiscoverState.Idle;
            }
            _this.initSubscription.init();
        };
        this.openHelp = function () {
            if (_this.isSidebarEnabled) {
                _this.state = DiscoverState.SidebarOpen;
            }
            else {
                _this.state = DiscoverState.HelpScoutOpen;
                _this.Beacon("open");
            }
        };
        this.closeHelp = function () {
            if (_this.state === DiscoverState.HelpScoutOpen) {
                _this.Beacon("close");
            }
            _this.state = DiscoverState.Idle;
        };
        this.openChat = function () {
            _this.state = DiscoverState.HelpScoutOpen;
            _this.Beacon("open");
        };
    }
    Object.defineProperty(DiscoverStore.prototype, "isBeaconEnabled", {
        get: function () {
            return !this.usingFeature(FeatureFlag_1.default.DisableBeacon);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "isSidebarEnabled", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "Beacon", {
        get: function () {
            var beacon = window.Beacon;
            if (!beacon) {
                throw new Error("Attempted to access Help Scout Beacon but it was not found on the window");
            }
            return beacon;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "shouldInitBeacon", {
        get: function () {
            var hasCompletedOnboarding = !this.onboardingStore.shouldShowCensusCollector;
            return hasCompletedOnboarding && this.isBeaconEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "shouldShowHelpButton", {
        get: function () {
            var hasCompletedOnboarding = !this.onboardingStore.shouldShowCensusCollector;
            if (this.isSidebarEnabled) {
                return hasCompletedOnboarding;
            }
            else {
                return hasCompletedOnboarding && this.isBeaconEnabled;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "isHelpOpen", {
        get: function () {
            return this.state !== DiscoverState.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "isSidebarOpen", {
        get: function () {
            return this.state === DiscoverState.SidebarOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiscoverStore.prototype, "shouldShowTrialPill", {
        get: function () {
            return this.isSidebarEnabled && this.trial.isOnTrial();
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], DiscoverStore.prototype, "state", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DiscoverStore.prototype, "upgradeTrialAccount", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DiscoverStore.prototype, "openHelp", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DiscoverStore.prototype, "closeHelp", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DiscoverStore.prototype, "openChat", void 0);
    DiscoverStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("onboardingStore")),
        __param(1, (0, inversify_1.inject)("usingFeature")),
        __param(2, (0, inversify_1.inject)("di")),
        __param(3, (0, inversify_1.inject)("initSubscription")),
        __param(4, (0, inversify_1.inject)("trial")),
        __metadata("design:paramtypes", [typeof (_a = typeof OnboardingStore_1.default !== "undefined" && OnboardingStore_1.default) === "function" ? _a : Object, typeof (_b = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _b : Object, typeof (_c = typeof HeroinTypes_1.IHeroin !== "undefined" && HeroinTypes_1.IHeroin) === "function" ? _c : Object, Object, Object])
    ], DiscoverStore);
    return DiscoverStore;
}());
exports.default = DiscoverStore;
